<mat-checkbox
  color="primary"
  class="mat-option"
  [indeterminate]="isIndeterminate()"
  [checked]="isChecked()"
  (click)="$event.stopPropagation()"
  (change)="toggleSelection($event)"
>
  <span [class.text-primary]="isChecked() || isIndeterminate()">{{ text }}</span>
</mat-checkbox>
